import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const Questions = () => {
  return (
    <>
      {/* Primer acordeón */}
      <Accordion
        sx={{
          background: 'rgb(246, 246, 246)',
          boxShadow: 'none',
          margin: 0,
          '&:before': {
            display: 'none',
          },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          sx={{
            flexDirection: 'row-reverse',
            '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
              transform: 'rotate(90deg)',
            },
            '& .MuiAccordionSummary-expandIconWrapper': {
              marginRight: '-8px',
              marginLeft: '16px',
            },
            alignItems: 'center',
            boxShadow: 'none',
            margin: 0,
          }}
        >
          <Typography sx={{ marginLeft: '10px' }}>
            <strong>¿En qué consiste el servicio de Revisión y Puesta a Punto?</strong>
          </Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            boxShadow: 'none',
            margin: 0,
          }}
        >
          <Typography>
            El servicio permite revisar de manera automática los puntos críticos que afectan al funcionamiento de sus equipos informáticos, como por ejemplo el espacio en disco duro, memoria virtual, archivos temporales, seguridad, etc.

            Una vez realizado el análisis, la aplicación genera un informe detallando los resultados; en caso necesario, nuestros técnicos podrán ayudarle a corregir y optimizar el rendimiento de su equipo de manera inmediata.
          </Typography>
        </AccordionDetails>
      </Accordion>

      {/* Segundo acordeón */}
      <Accordion
        sx={{
          background: 'rgb(246, 246, 246)',
          boxShadow: 'none',
          margin: 0,
          '&:before': {
            display: 'none',
          },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
          sx={{
            flexDirection: 'row-reverse',
            '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
              transform: 'rotate(90deg)',
            },
            '& .MuiAccordionSummary-expandIconWrapper': {
              marginRight: '-8px',
              marginLeft: '16px',
            },
            alignItems: 'center',
            boxShadow: 'none',
            margin: 0,
          }}
        >
          <Typography sx={{ marginLeft: '10px' }}>
            <strong>¿Cómo puedo comenzar a utilizar el servicio?</strong>
          </Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            boxShadow: 'none',
            margin: 0,
          }}
        >
          <Typography>
            Para hacer uso del servicio, deberá instalar el software que permite analizar el equipo de forma automática. Una vez instalado, podrá acceder e iniciar el análisis siempre que lo necesite a través del icono que aparecerá en su escritorio.

            El servicio se presta en horario ininterrumpido los 7 días de la semana, las 24 horas del día, de acuerdo a las condiciones particulares del servicio de Ayuda Tecnológica Online.
          </Typography>
        </AccordionDetails>
      </Accordion>

      {/* Tercer acordeón */}
      <Accordion
        sx={{
          background: 'rgb(246, 246, 246)',
          boxShadow: 'none',
          margin: 0,
          '&:before': {
            display: 'none',
          },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3a-content"
          id="panel3a-header"
          sx={{
            flexDirection: 'row-reverse',
            '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
              transform: 'rotate(90deg)',
            },
            '& .MuiAccordionSummary-expandIconWrapper': {
              marginRight: '-8px',
              marginLeft: '16px',
            },
            alignItems: 'center',
            boxShadow: 'none',
            margin: 0,
          }}
        >
          <Typography sx={{ marginLeft: '10px' }}>
            <strong>¿Qué puntos revisa este servicio?</strong>
          </Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            boxShadow: 'none',
            margin: 0,
          }}
        >
          <Typography>
            <ul>
              <li>Análisis de seguridad: muestra todos los programas antivirus instalados en el equipo y su estado.</li>
              <li>Propiedades del sistema: esta tarea muestra información sobre el hardware y propiedades del sistema.</li>
              <li>Revisión de archivos temporales: este punto detalla la totalidad de archivos temporales presentes en el sistema, así como el espacio que ocupan en disco.</li>
              <li>Programas en el inicio: genera un listado con los programas que se ejecutan de manera automática al iniciar el sistema y que ralentizan el arranque del equipo.</li>
              <li>Espacio en disco: esta comprobación informa sobre el tipo de unidades de disco, tamaño total y espacio libre disponible.</li>
              <li>Memoria virtual: esta tarea informa sobre la configuración de la memoria virtual para saber si se gestiona de forma automática o manual.</li>
              <li>Punto de restauración (sólo Windows): durante la revisión se creará automáticamente un punto de restauración que permite devolver el equipo a su estado previo.</li>
              <li>Copia de Seguridad (sólo Mac): esta tarea comprueba si el equipo está configurado para realizar copias de seguridad del sistema.</li>
            </ul>
          </Typography>
        </AccordionDetails>
      </Accordion>
    </>
  );
};

export default Questions;
